module.exports = __webpack_public_path__ + "static/media/landing-kitty03.e6be0f6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/landing-kitty03.svg
// module id = 120
// module chunks = 0